import type { KeyboardEvent } from 'react';

/**
 * `<form onKeyDown={preventEnterSubmit}>` — 한 줄 입력칸의 엔터(폰 키보드의 '이동'·'완료' 포함)가 폼을 제출하지 않게 한다.
 * 폼 제출은 [저장]·[다음] 같은 버튼을 직접 눌렀을 때만(2026-10-06 — 칸에서 엔터를 누르면 브라우저 기본 제출로 저장·단계 이동이 됐다).
 *
 * - 칸이 엔터를 따로 쓰면(직접 입력 칩 추가 등) 그 칸이 먼저 처리하고 막는다 — 이미 막힌 이벤트는 건드리지 않는다.
 * - 한글 조합 중 엔터(isComposing·keyCode 229)는 그대로 둔다 — 막으면 조합 확정이 깨질 수 있고, 조합 중 엔터는 제출을 일으키지 않는다.
 * - 여러 줄 칸(textarea)·편집기·버튼의 엔터는 원래대로.
 */
export const preventEnterSubmit = (event: KeyboardEvent<HTMLElement>): void => {
    if (event.key !== 'Enter' || event.defaultPrevented) return;
    if (event.nativeEvent.isComposing || event.keyCode === 229) return;
    const target: EventTarget | null = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (['button', 'submit', 'reset', 'checkbox', 'radio', 'file', 'image', 'range', 'color'].includes(target.type)) return;
    event.preventDefault();
};
